<template>
  <div id="password">
    <div id="container">
      <div id="content">
        <div id="title">初回パスワード設定</div>
        <form @submit="confPass">
          <div class="row">
            <label>パスワード</label>
            <input
              type="password"
              v-model="form.password"
            />
            <div class="error_message">{{ fieldErrorMessages.password }}</div>
          </div>
          <div class="row">
            <label>確認用パスワード</label>
            <input
              type="password"
              v-model="form.confirmPassword"
            />
            <div class="error_message">{{ fieldErrorMessages.confirmPassword }}</div>
            <div v-if="fieldErrorMessages.CustomConstraint" class="error_message">
              {{ fieldErrorMessages.CustomConstraint }}
            </div>
          </div>
          <button type="submit" class="main_btn">設定</button>
        </form>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import Footer from '../components/common/Footer'
import {API_URL, STORAGE_KEY} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
export default {
  name: 'Password',
  components: {
    'dd-footer': Footer
  },
  data () {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        password: '',
        confirmPassword: '',
        CustomConstraint: ''
      }
    }
  },
  methods: {
    confPass: function (event) {
      event.preventDefault()
      this.clearMessages()
      let payload = {
        password: this.form.password,
        confirmPassword: this.form.confirmPassword
      }
      axios.post(API_URL.PASSWORD + '/update', payload
      ).then(response => {
        alert('パスワード変更設定しました')
        const user = App.getLocalStorage(STORAGE_KEY.USER_INFO)
        if (user.licenseType !== 4) {
          this.$router.push('/')
        } else {
          this.$router.push('/planning')
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        loginId: '',
        password: '',
        CustomConstraint: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#password{
  height: calc(100% - 50px);
}
#container {
  height: 100%;
  display: flex;
  justify-content: center;
}
#content {
  padding-top: 30px;
  text-align: center;
  display: block;
  #title{
    margin-bottom: 20px;
  }
  form {
    padding: 20px 50px;
    border-radius: 5px;
    background-color: #fff;
    input {
      width: 200px;
    }
  }
}
#page-title {
  margin-bottom: 25px;
}
.error_message {
  margin: 10px;
}
.row {
  margin-bottom: 10px;
}
label{
  min-width: 130px;
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Password.vue